import { createApacheConfig, ThemeName } from '@toggle/design-system';
import { getInstanceByDom } from 'echarts';

import { htmlNodes } from './htmlNodes';

export const generateImageTag = (chartRef: HTMLDivElement) => {
  const canvas = chartRef?.querySelector('canvas');

  if (!canvas) {
    return '';
  }

  const chartInstance = getInstanceByDom(chartRef);

  if (!chartInstance) {
    return htmlNodes.img(canvas.toDataURL('image/png', 1.0));
  }

  const originalOptions = chartInstance.getOption();

  const lightThemeOptions = createApacheConfig({
    theme: 'light_default' as ThemeName,
    options: originalOptions as any,
  });

  chartInstance.setOption(lightThemeOptions);
  const imageDataUrl = canvas.toDataURL('image/png', 1.0);

  chartInstance.setOption(originalOptions);

  return htmlNodes.img(imageDataUrl);
};
